// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"eu-z","imageAndVideoCount":"fu-z","imageAndVideoContainer":"gu-z","viewAllReviews":"hu-z"};